@if (_active) {
  <kendo-window
    #mainWindow
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4"
    (keydown.enter)="$event.preventDefault()">
    <form novalidate class="form_style maintenance-type-upsert">
      <div class="row special_row_margin">
        <div class="col-6 special_col_padding" [class.col-12]="_pageState == 2 || _pageState == 4 || _currentUser?.isEnterprise">
          <div class="border_sections margin-top-4">
            <!-- Main Popup Actions and Title -->
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Maintenance Type
                  @if (canAccess(_permissionScope, 'update')) {
                    <span (click)="_edit()" [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img [src]="'/assets/menu/'+ _theme +'/edit-action-icon-grid.svg'" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  @if (_pageState != 1) {
                    <div>
                      <button class="steps_buttons_class" kendoButton (click)="_onCancel()" type="button">
                        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                        <span>close</span>
                      </button>
                      @if (canAccess(_permissionScope, 'create')) {
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="isSaving" (click)="_onSave('saveAndCopy')" type="button">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Copy</span>
                        </button>
                      }
                      @if (canAccess(_permissionScope, 'create')) {
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="isSaving" (click)="_onSave('saveAndNew')" type="button">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & New</span>
                          </button>
                        }
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="isSaving" (click)="_onSave('saveAndClose')" type="button">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                        <button class="steps_buttons_class"
                          kendoButton [disabled]="isSaving" (click)="_onSave('save')" type="button">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12">
                  <div class="formsMenuSeparator"></div>
                </div>
              </div>
              <!-- Popup Content -->
              <div class="row row_padding">
                <fieldset class="col-12" [class.col-6-imp]="_pageState == 1 || _pageState == 2 || _pageState == 3 || _pageState == 4 || _currentUser?.isEnterprise">
                  <!-- Maintenance Type Code -->
                  <div class="form-group from_but_container special_style_formgroup margin-top-10">
                    <label for="maintenanceTypeCode" class="control-label">
                      Maintenance Type
                    </label>
                    <input #kendo_MaintenanceTypeCode
                      id="maintenanceTypeCode"
                      type="text"
                      [class.ViewModeDisabledControl]="_pageState == 1"
                      class="k-textbox writebox min-width-0 newFormControlWidth bordered"
                      placeholder="Maintenance Type"
                      [(ngModel)]="maintenanceTypeCode"
                      [ngModelOptions]="{ standalone: true }"
                      [attr.disabled]="(_pageState == 2 || _pageState == 3) ? null : 'disabled'"
                      [disabled]="(_pageState == 2 || _pageState == 3) ? false : true"
                      maxlength="100"
                      required />
                    </div>
                    <!-- Maintenance Type Name -->
                    <div class="form-group from_but_container special_style_formgroup margin-top-10">
                      <label for="maintenanceTypeName" class="control-label">
                        Maintenance Type Name
                      </label>
                      <input #kendo_MaintenanceTypeName
                        id="maintenanceTypeName"
                        type="text"
                        [class.ViewModeDisabledControl]="_pageState == 1"
                        class="k-textbox writebox min-width-0 newFormControlWidth bordered"
                        placeholder="Maintenance Type Name"
                        [(ngModel)]="maintenanceTypeName"
                        [ngModelOptions]="{ standalone: true }"
                        [attr.disabled]="(_pageState == 2 || _pageState == 3) ? null : 'disabled'"
                        [disabled]="(_pageState == 2 || _pageState == 3) ? false : true"
                        maxlength="200" />
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-window>
      }
